import React from 'react';
import {
	ExpansionPanel,
	Card,
	CardContent,
	ExpansionPanelSummary,
	Icon,
	Typography,
	ExpansionPanelDetails
} from '@material-ui/core';
import LifeCover from './BenefitQuestions/LifeCover.jsx';
import CriticalIllness from './BenefitQuestions/CriticalIllness.jsx';
import DisabilityLumpsum from './BenefitQuestions/DisabilityLumpsum.jsx';
import ExtIncomeProtector from './BenefitQuestions/ExtIncomeProtector.jsx';
import TempIncomeProtector from './BenefitQuestions/TempIncomeProtector.jsx';
import DeathIncomeProtector from './BenefitQuestions/DeathIncomeProtector.jsx';

import CustomCardHeading from 'components/CustomCardHeading/CustomCardHeading.jsx';

class BenefitDetails extends React.Component {
	state = {
		benefitValidity: {
			3: true,
			5: true,
			55: true,
			56: true,
			57: true,
			58: true
		}
	};

	setBenefitValidity = (benefitId, valid) => {
		if (this.state.benefitValidity[benefitId] === valid) return;

		const benefitValidity = { ...this.state.benefitValidity };
		benefitValidity[benefitId] = valid;
		this.setState({ benefitValidity: benefitValidity });
	};

	benefitComponents = [
		{
			id: 3,
			name: 'Life Cover',
			component: props => (
				<LifeCover
					{...props}
					setBenefitValidity={valid => this.setBenefitValidity(3, valid)}
				/>
			)
		},
		{
			id: 5,
			name: 'Critical Illness',
			component: props => (
				<CriticalIllness
					{...props}
					setBenefitValidity={valid => this.setBenefitValidity(5, valid)}
				/>
			)
		},
		{
			id: 55,
			name: 'Disability Lumpsum',
			component: props => (
				<DisabilityLumpsum
					{...props}
					setBenefitValidity={valid => this.setBenefitValidity(55, valid)}
				/>
			)
		},
		{
			id: 56,
			name: 'Temporary Income Protector',
			component: props => (
				<TempIncomeProtector
					{...props}
					setBenefitValidity={valid => this.setBenefitValidity(56, valid)}
				/>
			)
		},
		{
			id: 57,
			name: 'Extended Income Protector',
			component: props => (
				<ExtIncomeProtector
					{...props}
					setBenefitValidity={valid => this.setBenefitValidity(57, valid)}
				/>
			)
		},
		{
			id: 58,
			name: 'Death Income Protector (Beta)',
			component: props => (
				<DeathIncomeProtector
					{...props}
					setBenefitValidity={valid => this.setBenefitValidity(58, valid)}
				/>
			)
		}
	];

	componentDidMount() {
		this.props.scrollMeBar();
	}

	render() {
		const filteredBenefit = this.benefitComponents.filter(b =>
			this.props.selectedBenefits.includes(b.id)
		);

		const benefitValidity = { ...this.state.benefitValidity };
		let invalidBenefits = false;
		for (var key in benefitValidity) {
			if (!benefitValidity[key]) {
				invalidBenefits = true;
				break;
			}
		}

		return (
			<div className="contentWithStepper">
				<Card>
					<CardContent>
						<CustomCardHeading
							subheading="Quote Generation"
							caption={this.props.clientFullname}
							headline="Benefit Details"
						/>
						{invalidBenefits ? (
							<Typography style={{ color: 'red' }}>
								<strong>Please Note: </strong>You have invalid benefit details
								for certain companies. Continuing might cause quotation errors.
							</Typography>
						) : null}
						{filteredBenefit.map((benefit, i) => {
							return (
								<ExpansionPanel defaultExpanded={i === 0} key={i}>
									<ExpansionPanelSummary expandIcon={<Icon>expand_more</Icon>}>
										<Typography>{benefit.name}</Typography>
									</ExpansionPanelSummary>
									<ExpansionPanelDetails>
										{benefit.component(this.props)}
									</ExpansionPanelDetails>
								</ExpansionPanel>
							);
						})}
					</CardContent>
				</Card>
			</div>
		);
	}
}

export default BenefitDetails;



// WEBPACK FOOTER //
// ./src/views/Quote/QuoteWizard/steps/BenefitDetails.jsx